import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformDeskCard } from "./-components/platform-desk-card";

export const Route = createFileRoute("/_authenticated/platform_/desk")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-desk"),
  component: PlatformDesk,
});

/** Setting up Sarah on People AI's lines. */
function PlatformDesk() {
  return (
    <div className="space-y-6">
      <PageHeader title="People AI desk" meta="How Sarah answers People AI's lines." />
      <PlatformDeskCard />
    </div>
  );
}
